import { useLang } from "@/context/LangContext";

export const ValueProposition = () => {
  const { tr } = useLang();
  return (
  <section data-testid="value-proposition" className="border-b border-[#cfd6d9]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
      <div className="max-w-4xl">
        <div className="text-[10px] uppercase tracking-widest font-mono text-[#E0262C] mb-4">{tr("Tutto in una sola soluzione", "All in one solution")}</div>
        <h2 className="font-display text-3xl sm:text-4xl leading-tight">
          {tr("Quello che oggi richiede molti fornitori e molte ore di gestione, ", "What today takes many suppliers and many hours of management, ")}<span className="aurora-text">{tr("noi lo consegniamo in una sola piattaforma, chiavi in mano", "we deliver in a single, turnkey platform")}</span>
        </h2>
      </div>
    </div>
  </section>
  );
};
